import { defineAsyncComponent } from "vue";

export default (app) => {
  /* ATOMS
   -------------------------------------------------------------*/
  app.component(
    "M4Select2",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "select2" */
        "./components/atoms/select2/select2.vue"
      )
    )
  );

  /* MOLECULES
   -------------------------------------------------------------*/
  app.component(
    "M4AssignedPerson",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "assigned-person" */
        "./components/molecules/assigned-person/assigned-person.vue"
      )
    )
  );

  /* ORGANISMS
   -------------------------------------------------------------*/
  app.component(
    "M4PeopleList",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "people-list" */
        "./components/organisms/people-list/people-list.vue"
      )
    )
  );

  app.component(
    "M4ImageGallery",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "image-gallery" */
        "./components/organisms/image-gallery/image-gallery.vue"
      )
    )
  );

  app.component(
    "M4LightBox",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "lightbox" */
        "./components/organisms/lightbox/lightbox.vue"
      )
    )
  );

  app.component(
    "M4TinyForm",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "tiny-form" */
        "./components/organisms/tiny-form/tiny-form.vue"
      )
    )
  );

  app.component(
    "M4SlottingTool",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "slotting-tool" */
        "./components/organisms/slotting-tool/slotting-tool.vue"
      )
    )
  );

  app.component(
    "M4QrCodeReader",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "qr-code-reader" */
        "./components/organisms/qr-code-reader/qr-code-reader.vue"
      )
    )
  );

  app.component(
    "M4QrCodeChecker",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "qr-code-checker" */
        "./components/organisms/qr-code-checker/qr-code-checker.vue"
      )
    )
  );

  app.component(
    "M4QrCodeSurvey",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "qr-code-survey" */
        "./components/organisms/qr-code-survey/qr-code-survey.vue"
      )
    )
  );

  app.component(
    "M4PersonOnsiteTool",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "person-onsite-tool" */
        "./components/organisms/person-onsite-tool/person-onsite-tool.vue"
      )
    )
  );

  app.component(
    "M4CompanyOnsiteTool",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "company-onsite-tool" */
        "./components/organisms/company-onsite-tool/company-onsite-tool.vue"
      )
    )
  );

  app.component(
    "M4SeatingTool",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "seating-tool" */
        "./components/organisms/seating-tool/seating-tool.vue"
      )
    )
  );

  app.component(
    "M4ImageCropper",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "image-cropper" */
        "./components/organisms/image-cropper/image-cropper.vue"
      )
    )
  );

  app.component(
    "M4EposGoTool",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "epos-go-tool" */
        "./components/organisms/epos-go-tool/epos-go-tool.vue"
      )
    )
  );

  app.component(
    "M4EposGoPresentationScreen",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "epos-go-presentation-screen" */
        "./components/organisms/epos-go-presentation-screen/epos-go-presentation-screen.vue"
      )
    )
  );

  app.component(
    "M4BoxAccordionForm",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "box-accordion-form" */
        "./components/organisms/box-accordion-form/box-accordion-form.vue"
      )
    )
  );

  app.component(
    "M4EposGoProgramme",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "epos-go-programme" */
        "./components/organisms/epos-go-programme/epos-go-programme.vue"
      )
    )
  );
};
